@keyframes pulse {
  0% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 var(--tuna-palette-secondary-light, rgba(186, 104, 200, 0.7));
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 8px transparent;
  }
  100% {
    transform: scale(0.8);
    box-shadow: 0 0 0 0 transparent;
  }
}

.blob {
  background: var(--tuna-palette-secondary-main);
  border-radius: 50%;
  margin: 8px;
  transform: scale(1);
  animation: pulse 2s infinite;
}

.placeholder {
  margin-left: 8px;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}
